import { Camera } from '../../camera';
import { Context } from '../../context/Context';
import { DrawableObject, RenderConfiguration, RenderMode, RenderSettings } from '../../renderer';
import { PropertyAnimation } from '../../animation';
import { ObjectInteraction } from '../ObjectManager';

/**
 * Abstract base class for sky implementations. Concrete subclasses (e.g.
 * {@link SkyBox} for image cubemaps, {@link ProceduralSky} for analytical
 * atmospheric scattering) plug into the same render slot in
 * {@link DeferredSceneRenderer} via the standard {@link DrawableObject}
 * contract.
 *
 * All skies share the same render configuration: drawn once in the Primary
 * pass between SSAO and lighting, never culled, never shadowed, never animated.
 */
export abstract class Sky implements DrawableObject {
  public renderConfiguration: RenderConfiguration = {
    static: true,
    culling: 'none',
    shadow: 'none',
    order: 0,
    modes: [RenderMode.Primary],
  };

  animatedProperties?: PropertyAnimation;
  interaction?: ObjectInteraction;

  /** Multiplicative tint applied to the sky output. Driven by DayNightCycleFeature. */
  public tintColor: [number, number, number] = [1, 1, 1];

  abstract render(ctx: Context, camera: Camera, settings: RenderSettings): void;
}
